import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=245c7b80&"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ResetPasswordPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports